import _ from 'lodash'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Map, List, isImmutable, fromJS } from 'immutable'
import { resetProjectPreviewPrintFlag } from '../../store/project/resetProjectPreviewPrintFlag'
import { addToSFQuery } from '../../store/project/addToSFQuery'
import { processSFActionQuery } from '../../store/project/processSFActionQuery'
import { processParamsUpdate } from '../../store/project/processParamsUpdate'
import { processSFAutoTrigger } from '../../store/project/processSFAutoTrigger'
import { processCondCache, processConditionQueCache } from '../../store/project/processCondCache'
import { isSame } from '../WidgetBuilder/UI/isSame'

const toJS = (val) => (isImmutable(val) ? val.toJS() : val)

export function SFActionProcessor(props) {
  const dispatch = useDispatch()
  const isNeedCall = useSelector((state) => state.getIn(['sfActions', 'needCall'], false), isSame)
  const isNeedPrint = useSelector((state) => state.getIn(['sfActions', 'isNeedPrint'], false), isSame)
  const params = useSelector((state) => state.getIn(['sfActions', 'params'], List()), isSame)
  const __cache__ = useSelector((state) => state.getIn(['__cache__'], List()), isSame)
  const inProcess = useRef(false)
  const triggerInProcess = useRef(false)
  const queryProccess = useRef(false)
  const [isNeedCallTrigger, setCallTrigger] = useState(false)
  const query = useSelector((state) => state.getIn(['query', 'list'], List()), isSame)

  const callTrigger = async () => {
    if (isNeedCallTrigger && triggerInProcess.current === false) {
      triggerInProcess.current = true
      setCallTrigger(false)
      await dispatch(processSFAutoTrigger())
      triggerInProcess.current = false
    }
  }

  const processQuery = async () => {
    if (query.size > 0) {
      queryProccess.current = query.getIn([0, 'value'])
      await dispatch(processSFActionQuery(0, false))
      queryProccess.current = ''
    }
  }

  useEffect(() => {
    if (query.size > 0 && queryProccess.current != query.getIn([0, 'value'])) {
      processQuery()
    }
    if (query.size === 0) {
      queryProccess.current = ''
      if (__cache__.size > 0) {
        dispatch(processCondCache(__cache__))
      }
    }
  }, [queryProccess, query, __cache__])

  useEffect(() => {
    if (isNeedPrint) {
      dispatch(resetProjectPreviewPrintFlag())
      setTimeout(function () {
        window.print()
      }, 300)
    }
  }, [isNeedPrint])

  useEffect(() => {
    if (isNeedCallTrigger) {
      callTrigger()
    }
  }, [isNeedCallTrigger])

  useEffect(() => {
    if (isNeedCall && inProcess.current === false) {
      inProcess.current = true
      try {
        if (params.size > 0) {
          dispatch(addToSFQuery([]))
        }
      } catch (error) {
        console.error(error, error.stack)
      }
      inProcess.current = false
    }
  }, [isNeedCall, inProcess])

  return null
}
